import { getSecurityProfile, SecurityProfile } from './api';
import { removeToken, setToken } from '@/utils/cookies';
import { clearLoginState, SECURITY_EVENT } from './storage';
import { startIdleSession } from './idleSession';

// Only ordinary login uses this flow. Password recovery keeps its original API contract.
export async function prepareLogin(token: string): Promise<void> {
  clearLoginState();
  startIdleSession(token, true);
  setToken(token);
  try {
    // Persist first so the unchanged common interceptor uses this login's token.
    await loadSecurityProfile(token, true);
  } catch (error) {
    removeToken();
    throw error;
  }
}

// Cache only in memory: reloads must obtain the password-change flag from the server.
let cache: { token: string; profile: SecurityProfile } | undefined;
let pending: { token: string; promise: Promise<SecurityProfile> } | undefined;
let generation = 0;
export function invalidateSecurityProfile() {
  generation += 1;
  cache = undefined;
  pending = undefined;
}
window.addEventListener(SECURITY_EVENT, invalidateSecurityProfile);
export function loadSecurityProfile(token: string, force = false): Promise<SecurityProfile> {
  if (!force && cache?.token === token) return Promise.resolve(cache.profile);
  if (!force && pending?.token === token) return pending.promise;
  generation += 1;
  const currentGeneration = generation;
  const promise = getSecurityProfile(token)
    .then((profile) => {
      if (currentGeneration === generation) cache = { token, profile };
      return profile;
    })
    .finally(() => {
      if (pending?.promise === promise) pending = undefined;
    });
  pending = { token, promise };
  return promise;
}
